import {
  Component,
  Output,
  Input,
  EventEmitter,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { faTrashAlt, faBell } from "@fortawesome/pro-light-svg-icons";
import { alertTypeEnum } from "../alert-settings-page.model";
//import { AlertSettingsPageDataService } from "../alert-settings-page-data.service";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Router } from "@angular/router";
import {
  VAIconRegistryService,
  plusCircle,
  trash,
} from "@va/core-library/icons";

@Component({
  selector: "app-alert-settings-filter-panel",
  templateUrl: "./alert-settings-filter-panel.component.html",
  styleUrls: ["./alert-settings-filter-panel.component.scss"],
})
export class AlertSettingsFilterPanelComponent implements OnInit {
  @Input() alertCompanyData: Array<Dictionary<any>>;
  @Input() selectedRows: Array<any>;
  @Output() selectCompany: EventEmitter<string> = new EventEmitter();
  @Output() onAlertTypeChange: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteClicked: EventEmitter<any> = new EventEmitter();
  @Output() onAddAlert: EventEmitter<any> = new EventEmitter();
  alertTypeEnum = alertTypeEnum;
  showAlertsModal = false;
  faPlusCircle = faPlusCircle;
  alertType = alertTypeEnum.company;
  companyOptions = { name: "", data: [] };
  noCompanyMsg = null;
  companyToSearch;
  selectedCompany;
  faBell = faBell;
  faTrash = faTrashAlt;
  showDropdown = false;
  deleteEnable = false;
  companyChange: Subject<string> = new Subject<string>();

  constructor(
    private router: Router,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([trash, plusCircle]);
  }

  ngOnInit() {
    this.companyChange
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((keyword) => this.searchCompany(keyword));
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.selectedRows &&
      changes.selectedRows.currentValue !== changes.selectedRows.previousValue
    ) {
      this.selectedRows = changes.selectedRows.currentValue;
      const hasCoveredCompany =
        this.alertType === "watchlist" &&
        this.selectedRows.filter((val) => val.actions.id === -1).length > 0;
      this.deleteEnable = this.selectedRows.length > 0 && !hasCoveredCompany;
    }
  }
  handleAlertsModal(bool: boolean) {
    this.showAlertsModal = bool;
  }
  alertSet() {
    this.handleAlertsModal(false);
    this.onAddAlert.emit();
  }

  handleAlertTypeChange(value: alertTypeEnum) {
    this.alertType = value;
    this.onAlertTypeChange.emit(alertTypeEnum[value]);
  }

  onCompanySelect(option) {
    this.selectCompany.emit(option);
  }

  searchCompanyDebounced(keyword) {
    this.companyChange.next(keyword);
  }
  searchCompany(keyword) {
    this.companyToSearch = keyword;
    if (keyword.trim().length) {
      const keywordL = keyword.toLowerCase();
      let filteredCompanies = this.alertCompanyData.filter((company) => {
        return (
          (company.companyName &&
            company.companyName.toLowerCase().indexOf(keywordL) !== -1) ||
          (company.ticker &&
            company.ticker.toLowerCase().indexOf(keywordL) !== -1)
        );
      });
      if (filteredCompanies.length) {
        let exactMatch = [];
        const exactMatchIndex = filteredCompanies.findIndex(
          (company) =>
            company.companyName.toLowerCase() === keywordL ||
            company.ticker.toLowerCase() === keywordL,
        );
        if (exactMatchIndex !== -1) {
          exactMatch = filteredCompanies.splice(exactMatchIndex, 1);
        }
        filteredCompanies.sort((companyA, companyB) => {
          if (
            companyA.companyName.toLowerCase() <
            companyB.companyName.toLowerCase()
          ) {
            return -1;
          }
          if (
            companyA.companyName.toLowerCase() >
            companyB.companyName.toLowerCase()
          ) {
            return 1;
          }

          return 0;
        });
        filteredCompanies = [...exactMatch, ...filteredCompanies];
        this.companyOptions = {
          name: `Company(${filteredCompanies.length})`,
          data: filteredCompanies,
        };
      } else {
        this.noCompanyMsg = `No match for "${keyword}"`;
        this.companyOptions = {
          name: "",
          data: [],
        };
      }
      this.showDropdown = true;
    } else {
      this.showDropdown = false;
    }
  }
  deleteAlerts() {
    this.onDeleteClicked.emit();
  }
  redirectWatchlist() {
    this.router.navigateByUrl("/watchlist");
  }
  // used from alert-settings-page-component using viewChild
  setSelectedCompany(ticker) {
    this.selectedCompany = ticker;
    this.onCompanySelect(ticker);
  }
}
